import { r4Client, r4Error } from '../../services'
import useLogger from '@/composables/useLogger'
const logger = useLogger('EmailCampaignStore')

const emailCampaignParams = payload => {
  return payload
}

const EmailCampaignStore = {
  namespaced: true,
  state: {
    emailCampaigns: [],
    emailCampaign: { },
    userMappableMergeTags: [],
    userNonMappableMergeTags: [],
    allMergeTags: [],
    requiredFieldMappingTags: [],
    scheduledCampaigns: []
  },
  mutations: {
    saveEmailCampaigns: (state, payload) => (state.emailCampaigns = payload.data),
    saveEmailCampaign: (state, payload) => (state.emailCampaign = payload.data),
    resetEmailCampaign: state => (state.emailCampaign = {}),
    saveUserMappableMergeTags: (state, payload) => (state.userMappableMergeTags = payload.data),
    saveUserNonMappableMergeTags: (state, payload) => (state.userNonMappableMergeTags = payload.data),
    saveAllMergeTags: (state, payload) => (state.allMergeTags = payload.data),
    saveRequiredFieldMappingTags: (state, payload) => (state.requiredFieldMappingTags = payload.data),
    saveScheduledCampaigns: (state, payload) => (state.scheduledCampaigns = payload.data)
  },
  actions: {
    fetchEmailCampaigns ({ state, commit }, payload) {
      return new Promise((resolve, reject) => {
        r4Client()
          .get('/api/v1/email_campaigns', { params: payload })
          .then(response => {
            commit('saveEmailCampaigns', response.data)
            resolve(state.emailCampaigns)
          })
          .catch(error => {
            reject(r4Error(error))
          })
      })
    },
    createEmailCampaign ({ state, commit }, payload) {
      const emailCampaignData = emailCampaignParams(payload)
      return new Promise((resolve, reject) => {
        r4Client()
          .post('/api/v1/email_campaigns', emailCampaignData)
          .then(response => {
            logger.trace('CreateEmailCampaign: Success')
            commit('saveEmailCampaign', response.data)
            resolve(state.emailCampaign)
          })
          .catch(error => {
            reject(r4Error(error))
          })
      })
    },
    updateEmailCampaign ({ state, commit }, payload) {
      const emailCampaignData = emailCampaignParams(payload)
      return new Promise((resolve, reject) => {
        r4Client()
          .put(`/api/v1/email_campaigns/${payload.id}`, emailCampaignData)
          .then(response => {
            logger.trace('UpdateEmailCampaign: Success')
            commit('saveEmailCampaign', response.data)
            resolve(state.emailCampaign)
          })
          .catch(error => {
            reject(r4Error(error))
          })
      })
    },
    // determines if create or update should be used
    saveEmailCampaign ({ dispatch }, payload) {
      return new Promise((resolve, reject) => {
        let savePromise = null
        if (payload.id) {
          savePromise = dispatch('updateEmailCampaign', payload)
        } else {
          savePromise = dispatch('createEmailCampaign', payload)
        }
        savePromise.then(resp => resolve(resp)).catch(error => reject(error))
      })
    },
    getEmailCampaign ({ state, commit }, payload) {
      return new Promise((resolve, reject) => {
        return r4Client()
          .get(`/api/v1/email_campaigns/${payload.id}`)
          .then(response => {
            commit('saveEmailCampaign', response.data)
            resolve(state.emailCampaign)
          })
          .catch(error => {
            reject(r4Error(error))
          })
      })
    },
    deleteEmailCampaign ({ state, commit }, payload) {
      return new Promise((resolve, reject) => {
        return r4Client()
          .delete(`/api/v1/email_campaigns/${payload.id}`)
          .then(response => {
            commit('resetEmailCampaign')
            resolve({})
          })
          .catch(error => {
            reject(r4Error(error))
          })
      })
    },
    getUserMappableMergeTags ({ state, commit }) {
      return new Promise((resolve, reject) => {
        r4Client()
          .get('/api/v1/mergetags/user_mappable_tags')
          .then(response => {
            commit('saveUserMappableMergeTags', response.data)
            resolve(state.userMappableMergeTags)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    getUserNonMappableMergeTags ({ state, commit }) {
      return new Promise((resolve, reject) => {
        r4Client()
          .get('/api/v1/mergetags/user_non_mappable_tags')
          .then(response => {
            commit('saveUserNonMappableMergeTags', response.data)
            resolve(state.userNonMappableMergeTags)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    getAllMergeTags ({ state, commit }) {
      return new Promise((resolve, reject) => {
        r4Client()
          .get('/api/v1/mergetags/all_tags')
          .then(response => {
            commit('saveAllMergeTags', response.data)
            resolve(state.allMergeTags)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    getRequiredFieldMappingTags ({ state, commit }) {
      return new Promise((resolve, reject) => {
        r4Client()
          .get('/api/v1/mergetags/required_field_mapping_tags')
          .then(response => {
            commit('saveRequiredFieldMappingTags', response.data)
            resolve(state.requiredFieldMappingTags)
          })
          .catch(error => {
            reject(error)
          })
      })
    }
    // getScheduledCampaigns ({ state, commit }, payload) {
    //   return new Promise((resolve, reject) => {
    //     EmailCampaignApi.upcomingByDate(
    //       payload.dealerId,
    //       payload.startDate,
    //       payload.endDate
    //     )
    //       .then(response => {
    //         commit('saveScheduledCampaigns', response)
    //         resolve(state.scheduledCampaigns)
    //       })
    //       .catch(error => {
    //         reject(error)
    //       })
    //   })
    // }

  },
  getters: {
  }
}

export default EmailCampaignStore
